export async function getPropertyByCategory(categoryId) {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}properties/category/${categoryId}`);

    if (response.ok) return response.json();

    throw response;
}
